import React from "react";
import { Box } from "@chakra-ui/react";
import { Global } from "@emotion/react";
import { config } from "../../Firebase";

// Colored bar on top of non-production environments; production shows nothing.
const ENVIRONMENTS: { [projectId: string]: { label: string; bg: string } } = {
  "stalykurs-development": { label: "DEVELOPMENT", bg: "red.600" },
  "stalykurs-stage": { label: "STAGING", bg: "orange.400" },
};

const HEIGHT = "24px";

export const EnvironmentBar: React.FC = () => {
  const environment = ENVIRONMENTS[config.projectId as string];

  if (!environment) {
    return null;
  }

  return (
    <>
      {/* fixed elements offset themselves by --env-bar-height */}
      <Global
        styles={{
          ":root": { "--env-bar-height": HEIGHT },
          "#root": {
            paddingTop: "var(--env-bar-height)",
            boxSizing: "border-box",
          },
        }}
      />
      <Box
        alignItems="center"
        bg={environment.bg}
        color="white"
        display="flex"
        fontSize="12px"
        fontWeight="bold"
        height={HEIGHT}
        justifyContent="center"
        left={0}
        letterSpacing="0.1em"
        position="fixed"
        right={0}
        top={0}
        zIndex={1200}
      >
        {environment.label} · {config.projectId}
      </Box>
    </>
  );
};
